import $ from 'jquery';

const Cookies = {
  init() {
    const me = this;

    if (me.getCookie('mkcookie') != '1') {
      $('#app-cookie-bar').show();

      $('#app-cookie-bar .close-cookies-bar').on('click', function() {
        $('#app-cookie-bar').hide();
        me.createCookie('mkcookie', 1, 30);
      });
    }
  },
  /**
   * Get Cookie.
   * @param {string} cName
   * @return {string}
   */
  getCookie(cName) {
    if (document.cookie.length > 0) {
      let cStart = document.cookie.indexOf(cName + '=');
      if (cStart != -1) {
        cStart = cStart + cName.length + 1;
        let cEnd = document.cookie.indexOf(';', cStart);
        if (cEnd == -1) {
          cEnd = document.cookie.length;
        }
        return unescape(document.cookie.substring(cStart, cEnd));
      }
    }
    return '';
  },
  createCookie(name, value, days) {
    let expires;
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  },
};

export default Cookies;
